if (!customElements.get('collection-filter-pills')) {
  customElements.define('collection-filter-pills', class CollectionFilterPills extends HTMLElement {
    connectedCallback() {
      this.pillsEl = this.querySelector('.cfp__pills');
      this.gridWrapper = this.querySelector('.cfp__grid-wrapper');
      if (!this.pillsEl || !this.gridWrapper) return;

      this.sectionId = this.pillsEl.dataset.sectionId;

      this.pillsEl.addEventListener('click', (e) => {
        const pill = e.target.closest('.cfp__pill');
        if (!pill || pill.classList.contains('cfp__pill--active')) return;
        this.applyFilter(pill);
      });
    }

    async applyFilter(pill) {
      this.pillsEl.querySelectorAll('.cfp__pill').forEach(p => p.classList.remove('cfp__pill--active'));
      pill.classList.add('cfp__pill--active');
      this.gridWrapper.classList.add('cfp__grid-wrapper--loading');

      // pill.dataset.filterUrl is pre-built by Shopify (value.url_to_add or collection.url)
      const pillUrl = new URL(pill.dataset.filterUrl, window.location.origin);

      // Build a clean fetch URL: strip all existing filter params from current URL,
      // then apply only this pill's filter params — ensures mutually exclusive behaviour
      const fetchUrl = new URL(window.location.href);
      [...fetchUrl.searchParams.keys()].filter(k => k.startsWith('filter.')).forEach(k => fetchUrl.searchParams.delete(k));
      pillUrl.searchParams.forEach((v, k) => { if (k.startsWith('filter.')) fetchUrl.searchParams.set(k, v); });
      fetchUrl.searchParams.set('section_id', this.sectionId);

      try {
        const response = await fetch(fetchUrl.toString());
        if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);
        const text = await response.text();

        const doc = new DOMParser().parseFromString(text, 'text/html');
        const newGrid = doc.querySelector('.cfp__grid-wrapper');
        if (newGrid) this.gridWrapper.innerHTML = newGrid.innerHTML;

        // pushState with the clean URL (no section_id)
        const pushUrl = new URL(fetchUrl.toString());
        pushUrl.searchParams.delete('section_id');
        history.pushState({}, '', pushUrl.toString());
      } catch (err) {
        console.error('CollectionFilterPills: fetch error', err);
      } finally {
        this.gridWrapper.classList.remove('cfp__grid-wrapper--loading');
      }
    }
  });
}
